import React from 'react'

export default function ViewImg() {
  return (
    <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.04236 9.20508C1.04236 9.20508 5.04236 1.20508 12.0424 1.20508C19.0424 1.20508 23.0424 9.20508 23.0424 9.20508C23.0424 9.20508 19.0424 17.2051 12.0424 17.2051C5.04236 17.2051 1.04236 9.20508 1.04236 9.20508Z" stroke="#1D56C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12.0424 12.2051C13.6992 12.2051 15.0424 10.8619 15.0424 9.20508C15.0424 7.54822 13.6992 6.20508 12.0424 6.20508C10.3855 6.20508 9.04236 7.54822 9.04236 9.20508C9.04236 10.8619 10.3855 12.2051 12.0424 12.2051Z" stroke="#1D56C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
